<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column6">
				<h2>{{ header }}</h2>
				<p>{{ content }}</p>
			</div>
			<div class="columns column6">
				<form class="newsletter-form">
					<input type="text" :placeholder="email" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	email: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-form {
	width: 100%;
	display: flex;
	flex-flow: nowrap row;
	justify-content: space-between;
	align-items: center;
}

section {
	background: $background-color-dark;
	color: #fff;
	padding: 75px 0;

	.row {
		display: flex;
		flex-flow: wrap row;
		justify-content: space-between;
		align-items: center;
	}

	h2 {
		color: #fff;
	}

	::placeholder {
		color: $primary-text-color;
	}

	input {
		background: #fff;
		color: $primary-text-color;
		padding: 18px;
		border: none;
		width: 60%;
		appearance: none;
		outline: none;

		&.button {
			color: #fff;
			line-height: 21px;
			background: $primary-color;
			width: 40%;
			cursor: pointer;

			&:hover {
				background: $primary-color-hover;
			}
		}
	}
}

@media (max-width: 600px) {
	.newsletter-form {
		flex-flow: column wrap;
	}

	section input,
	section input.button {
		width: 100%;
	}
}
</style>
